module.exports = __webpack_public_path__ + "static/media/fondo-home-hoteles.a407db94.webp";